<div [innerHTML]="content | async "></div>